import { ButtonHTMLAttributes, DetailedHTMLProps, useState } from 'react';
import { classNames } from 'primereact/utils';

export type DocumentFilters = {
  type?: string | null;
  status?: 'Live' | 'Dead' | 'All';
};
export type DocumentFilterPanelProps = {
  agreementTypes: string[];
  filters: DocumentFilters;
  setFilter?: (
    filter: DocumentFilters | ((prev: DocumentFilters) => DocumentFilters),
  ) => void;
};
export const DocumentFilterPanel = ({
  agreementTypes,
  setFilter,
  filters,
}: DocumentFilterPanelProps) => {
  const [agreementTypeName, setAgreementTypeName] = useState<
    string | undefined
  >(undefined);
  const handleSetFilter = (
    prop: keyof DocumentFilters,
    filter: DocumentFilters[keyof DocumentFilters],
  ) => {
    if (setFilter) {
      setFilter((prev: DocumentFilters) => ({
        ...prev,
        [prop]: filter,
      }));
    }
  };

  return (
    <div className="pt-2 flex flex-row align-items-center flex-grow-0">
      <div>
        <span
          className={`mr-2 cursor-pointer inline-block ${agreementTypeName === 'All' ? 'bold' : 'text-color-secondary'}`}
          onClick={() => {
            setAgreementTypeName('All');
            if (setFilter) setFilter({ type: null });
          }}
        >
          All
        </span>
        {agreementTypes.map((at) => (
          <span
            key={`agreement-type-${at}`}
            className={`mr-2 cursor-pointer inline-block ${at === agreementTypeName ? 'bold' : 'text-color-secondary'}`}
            onClick={() => {
              setAgreementTypeName(at);
              if (setFilter) {
                setFilter((prev: DocumentFilters) => ({
                  ...prev,
                  type: at,
                }));
              }
            }}
          >
            {at}
          </span>
        ))}
      </div>
      <div className="bq-switch-button-group flex-1">
        <BqSwitchButton disabled={true} label={'Status:'} />
        <BqSwitchButton
          onClick={() => handleSetFilter('status', 'Live')}
          selected={filters?.status === 'Live'}
          label={'Live'}
        />
        <BqSwitchButton
          selected={filters?.status === 'Dead'}
          onClick={() => handleSetFilter('status', 'Dead')}
          label={'Archive'}
        />
        <BqSwitchButton
          selected={filters?.status === 'All'}
          onClick={() => handleSetFilter('status', 'All')}
          label={'All'}
        />
      </div>
    </div>
  );
};
export interface BqSwitchButton
  extends DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  selected?: boolean;
  label: string;
  buttonClasses?: string;
  innerClasses?: string;
  disabled?: boolean;
  color?: 'gray,success, error,info,warning';
}
export const BqSwitchButton = ({
  selected,
  disabled,
  label,
  onClick,
  ...rest
}: BqSwitchButton) => {
  return (
    <button
      {...rest}
      onClick={(e) => {
        if (!disabled && onClick) {
          onClick(e);
        }
      }}
      className={classNames({
        'bq-switch-button inline-block block': true,
        'cursor-pointer': !disabled,
        disabled: disabled,
        selected: selected,
        // 'p-button-secondary': !selected
      })}
    >
      <span
        className={classNames({
          'p-1 inline-block': true,
          selected: selected,
        })}
      >
        {label}
      </span>
    </button>
  );
};
